import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  buttonHome: {
    id: "error.button.home",
    defaultMessage: "На главный экран",
  },
  subtitle: {
    id: "error.subtitle.notFound",
    defaultMessage:
      "Похоже, эта страница сейчас недоступна или ее больше не существует",
  },
  title: {
    id: "error.title.notFound",
    defaultMessage: "Раздел не найден",
  },
});

export const useNotFoundMessages = () => {
  const { formatMessage } = useIntl();

  return {
    buttonText: formatMessage(messages.buttonHome),
    subtitle: formatMessage(messages.subtitle),
    title: formatMessage(messages.title),
  };
};
